import React, { useState } from "react";
import ReactPlayer from "react-player";
import Testimonials from "../Testimonial/Testimonials";

const ChooseUs = () => {
  const [showVideo, setShowVideo] = useState(false);
  return (
    <section id="chooseUs" className="chooseUs">
      <div className="chooseUs__testimonials">
        <Testimonials />
      </div>

      <div className="chooseUs__video">
        <div className="choose__img">
          {showVideo ? (
            <ReactPlayer
              url="https://youtube.com/shorts/F40a1JFdvn8?si=-9A-kzi5PJ4bNBei"
              controls
              width="100%"
              height="420px"
            />
          ) : (
            <img
              width={100}
              height={100}
              loading="lazy"
              src="./assets/images/why-choose-us.png"
              alt="Why Choose Seed To Tree"
              title="Why Choose Seed To Tree"
              className="w-100 h-100"
            />
          )}

          {!showVideo && (
            <span className="play__icon">
              <i
                className="ri-play-circle-line"
                onClick={() => setShowVideo(!showVideo)}
              ></i>
            </span>
          )}
        </div>
      </div>
    </section>
  );
};

export default ChooseUs;
